/**
 * Fixed Candidate Button Component
 * Shows/hides fixed button at bottom when scrolling on mobile
 */
export function renderFixedButton() {
    const candidateBtn = document.querySelector(".c-candidate-fixed");
    if (!candidateBtn) return;

    const scrollThreshold = 200; // Show button after scrolling 200px
    let isVisible = false;

    const handleScroll = () => {
        const currentScroll =
            window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > scrollThreshold) {
            if (!isVisible) {
                candidateBtn.style.display = "flex";
                // Delay for animation
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        candidateBtn.classList.add("is-visible");
                    });
                });
                isVisible = true;
            }
        } else {
            if (isVisible) {
                candidateBtn.classList.remove("is-visible");
                // Hide after animation completes
                setTimeout(() => {
                    if (!candidateBtn.classList.contains("is-visible")) {
                        candidateBtn.style.display = "none";
                    }
                }, 300);
                isVisible = false;
            }
        }
    };

    // Throttle scroll event for better performance
    let ticking = false;
    window.addEventListener("scroll", () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    // Check initial scroll position
    handleScroll();
}
